/*
 * Copyright Huesik (c) 2019.
 */

import axiosInstance from '../core/modules/axiosInstance'

const actions = {
  setRankingIsHide (context, isHide) {
    console.log(`setRankingIsHide : ${isHide}`)
    context.commit('SET_RANKING_IS_HIDE', isHide)
  },
  setBoundsDistance (context, distance) {
    console.log(`setBoundsDistance : ${distance}`)
    context.commit('SET_BOUNDS_DISTANCE', distance)
  },
  setMap (context, map) {
    console.log(`setMap : ${map}`)
    context.commit('SET_MAP', map)
  },
  setMapCenter (context, latlng) {
    console.log(`setMapCenter ${JSON.stringify(latlng)}`)
    context.commit('SET_MAP_CENTER', latlng)
  },
  setMapBounds (context, bounds) {
    console.log(`setMapBounds ${JSON.stringify(bounds)}`)
    context.commit('SET_MAP_BOUNDS', bounds)
  },
  setSearchKosiwonList (context, kosiwonList) {
    context.commit('SET_SEARCH_KOSIWON_LIST', kosiwonList)
  },
  setOpenStatus(context, openStatus) {
    context.commit('SET_OPEN_STATUS', openStatus)
  },
  setHoverKosiwon (context, kosiwon) {
    context.commit('SET_HOVER_KOSIWON', kosiwon)
  },
  setMoneyRange (context, moneyRange) {
    context.commit('SET_MONEY_RANGE', moneyRange)
  },
  setUseSexType (context, type) {
    context.commit('SET_USE_SEX_TYPE', type)
  },
  toggleOptions (context, key) {
    context.commit('TOGGLE_OPTIONS_FILTER', key)
  },
  toggleRoomType (context, type) {
    context.commit('TOGGLE_ROOM_TYPE', type)
  },
  async loginProcess ({commit}, userInfo) {
    try {
      console.log(userInfo)
      return await axiosInstance.post('/users/login', userInfo).then(({data}) => {
        commit('SET_LOGIN', data)
      })
    } catch (error) {
      console.error(error)
    }
  },

  async logout ({commit}) {
    try {
      commit('LOGOUT')
    } catch (error) {
      console.error(error)
    }
  },
  setPickList (context, kosiwon) {
    context.commit('SET_PICK_LIST', kosiwon)
  },
  removePickList (context, kosiwon) {
    context.commit('REMOVE_PICK_LIST', kosiwon)
  },
  setLastViewList (context, kosiwon) {
    context.commit('SET_LAST_VIEW_LIST', kosiwon)
  },

  resetFilter (context) {
    context.commit('RESET_FILTER_STATE')
  },
  toggleNetworkIndicator (context) {
    context.commit('TOGGLE_NETWORK_INDICATOR')
  },

  setNetworkIndicator (context, value) {
    context.commit('SET_NETWORK_INDICATOR', value)
  },
  setIsNative (context, isNative) {
    context.commit('SET_IS_NATIVE', isNative)
  },
  setAppFirstLoading (context, isLoading) {
    context.commit('SET_APP_FIRST_LOADING', isLoading)
  }
}

export default actions
